import api from "../../index";
import { qs } from "../../../utils/utils.js";

export const GetAllibApi = (params) => api.get(`admin/getallibuserlist?${qs(params)}`);
export const GetAllIBByIdApi = (IBId) => api.get(`admin/getsingleibuser/${IBId}`);
export const GetCommissionAssignTreeApi = (userId, params) => api.get(`ibusermaster/ib-commission-assign-tree/${userId}?${qs(params)}`);
export const GetAllAccountPlanApi = (params) => api.post('planmaster/get-all-plan-for-user', params);
export const IBRejectApproveApi = (data) => api.post('admin/ibrejectedapproved', data);